import { FONTS } from 'common/constants';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  font-family: ${FONTS.medium};
  padding: 15px;
  position: absolute;
  top: 40px;
  left: 50px;
  z-index: 1;
  box-shadow: 1px 1px 3px 1px rgba(1, 1, 1, 0.25);
`;

export const BreadcrumbLink = styled(Link)`
  color: ${({ theme }) => theme.colors.bodyText};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const BreadcrumbItem = styled.div`
  padding: 0 10px;
  line-height: 1;
  margin-bottom: -5px;
`;
